import { render, staticRenderFns } from "./instemplate.vue?vue&type=template&id=15656fe4&scoped=true&"
import script from "./instemplate.vue?vue&type=script&lang=js&"
export * from "./instemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15656fe4",
  null
  
)

export default component.exports